export default "__VITE_ASSET__278fda5a__"